import { render, staticRenderFns } from "./TellPeople.vue?vue&type=template&id=49029336"
import script from "./TellPeople.vue?vue&type=script&lang=ts"
export * from "./TellPeople.vue?vue&type=script&lang=ts"
import style0 from "./TellPeople.vue?vue&type=style&index=0&id=49029336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports